// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./App.css";
// import App from "./App";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// // import { createBrowserRouter, RouterProvider } from "react-router-dom";


// import Root from "./routes/root";
// import ErrorPage from "./error-page";
// import About from "./routes/about";

// // import Services from "./routes/services";
// // import WebDesign from "./routes/web-design";
// // import WebDev from "./routes/web-dev";
// // import Frontend from "./routes/frontend";
// // import Php from "./routes/php";
// // import NodeJs from "./routes/node";
// // import SEO from "./routes/seo";
// import Mission from "./routes/mission";
// import Inspiration from "./routes/inspiration"
// import Headofschool from "./routes/headofschool";
// import Feestructure from "./routes/feestructure";
// import Ourstaff from "./routes/ourstaff";
// import Pyp from "./routes/pyp";
// import Ibdp from "./routes/ibdp";
// import Igcse from './routes/igcse'
// import Policy from "./routes/policy"; 
// import Policynew from './routes/policynew'
// import Ibdphandbooks from "./routes/ibdphandbooks";
// import Cashandbooks from "./routes/cashandbooks";
// import Tokhandbooks from "./routes/tokhandbooks";
// import Eehandbooks from "./routes/eehandbooks";
// import Syllabus from "./routes/syllabus";
// import BookList from "./routes/bookList";
// import Curriculum from "./routes/curriculum";
// import Pyppoi from "./routes/pyppoi";
// import Popyp from "./routes/popyp";
// import Parentorientationforpyp from "./routes/parentorientationforpyp";
// import Parentorientationibdp from "./routes/parentorientationibdp";
// // import Mycalendar from "./routes/mycalendar";
// import Holidayhomework from "./routes/holidayhomework";
// import Homeassignments from "./routes/homeassignments";
// import Circular from "./routes/circular";
// import Newsletter from "./routes/newsletter";
// import Igceadmission from "./routes/igceadmission";
// import Ibdpadmission from "./routes/ibdpadmission";
// import Onlineregistration from "./routes/onlineregistration";
// import Ibdpupdate from "./routes/ibdpupdate";
// import Events from "./routes/events";
// import Classexhibition from "./routes/classexhibition";
// import Celebrations from "./routes/celebrations";
// import News from "./routes/news";
// import Videos from "./routes/videos";
// import Casexperiences from "./routes/casexperiences";
// import Schooltrips from "./routes/schooltrips";
// import Visualarts from "./routes/visualarts";
// import Onlinefess from "./routes/onlinefees";
// import Achievements from "./routes/achievements";
// import Placements from "./routes/placements";
// import Careercounselling from "./routes/careercounselling";
// import Contactus from "./routes/contactus";
// import Ibdphandbook from "./routes/ibdp-handbook";
// import Pdf1 from '../src/components/pdf/newsletter/ibpyp/Newsletter.pdf';
// // import Calendar2025 from '../src/components/pdf/Sanskar Calender 2024-25.pdf';
// import Pypsyllabus from "./routes/pypsyllabus";
// import Admission from "./routes/admission";
// import IgcseBooklist from "./routes/igcsebooklist";
// import Infra from "./routes/infra";
// import Sports from "./routes/sports"
// import Mycalendar from "./routes/mycalendar";
// import Career from "./routes/career"


// import 'react-big-calendar/lib/css/react-big-calendar.css';
// const router = createBrowserRouter([
//   {
//     element: <Root />,
//     errorElement: <ErrorPage />,
//     children: [
//       {
//         path: "/",
//         element: <App />,
//       },
//       {
//         path: "about",
//         element: <About/>,
//       },
//       {
//         path: "mission",
//         element: <Mission/>,
//       },
//       {
//         path: "inspiration",
//         element: <Inspiration/>,
//       },
//       {
//         path: "headofschool",
//         element: <Headofschool/>,
//       },
//       {
//         path: "feestructure",
//         element: <Feestructure/>,
//       },
//       {
//         path: "ourstaff",
//         element: <Ourstaff/>,
//       },
//       {
//         path: "pyp",
//         element: <Pyp/>,
//       },
//       {
//         path: "igcse",
//         element: <Igcse/>,
//       },
//       {
//         path: "ibdp",
//         element: <Ibdp/>,
//       },
//       {
//         path: "policy",
//         element: <Policy/>,
//         // element : <Policynew/>
//       },
//       {
//         path: "ibdphandbooks",
//         element: <Ibdphandbooks/>,
//       },
//       {
//         path: "cashandbooks",
//         element: <Cashandbooks/>,
//       },
//       {
//         path: "tokhandbooks",
//         element: <Tokhandbooks/>,
//       },
//       {
//         path: "eehandbooks",
//         element: <Eehandbooks/>,
//       },
//       {
//         path: "syllabus",
//         element: <Syllabus/>,
//       },
//       {
//         path: "bookList",
//         element: <BookList/>,
//       },
//       {
//         path: "curriculum",
//         element: <Curriculum/>,
//       },
//       {
//         path: "pyppoi",
//         element: <Pyppoi/>,
//       },
//       {
//         path: "popyp",
//         element: <Popyp/>,
//       },
//       {
//         path: "parentorientationforpyp",
//         element: <Parentorientationforpyp/>,
//       },
//       {
//         path: "parentorientationibdp",
//         element: <Parentorientationibdp/>,
//       },
//       {
//         path: "calendar",
//         element: <Mycalendar/>,
//       },
//       {
//         path: "holidayhomework",
//         element: <Holidayhomework/>,
//       },
//       {
//         path: "homeassignments",
//         element: <Homeassignments/>,
//       },
//       {
//         path: "circular",
//         element: <Circular/>,
//       },
//       {
//         path: "newsletter",
//         element: <Newsletter/>,
//       },
//       {
//         path: "igceadmission",
//         element: <Igceadmission/>,
//       },
//       {
//         path:"admission",
//         element: <Admission/>
//       },
//       {
//         path: "ibdpadmission",
//         element: <Ibdpadmission/>,
//       },
//       {
//         path: "onlineregistration",
//         element: <Onlineregistration/>,
//       },
//       {
//         path: "ibdpupdate",
//         element: <Ibdpupdate/>,
//       },
//       {
//         path: "events",
//         element: <Events/>,
//       },
//       {
//         path: "classexhibition",
//         element: <Classexhibition/>,
//       },
//       {
//         path: "celebrations",
//         element: <Celebrations/>,
//       },
//       {
//         path: "news",
//         element: <News/>,
//       },
//       {
//         path: "videos",
//         element: <Videos/>,
//       },
//       {
//         path: "casexperiences",
//         element: <Casexperiences/>,
//       },
//       {
//         path: "schooltrips",
//         element: <Schooltrips/>,
//       },
//       {
//         path: "visualarts",
//         element: <Visualarts/>,
//       },
//       {
//         path: "onlinefess",
//         element: <Onlinefess/>,
//       },
//       {
//         path: "achievements",
//         element: <Achievements/>,
//       },
//       {
//         path: "placements",
//         element: <Placements/>,
//       },
//       {
//         path: "careercounselling",
//         element: <Careercounselling/>,
//       },
//       {
//         path: "contact",
//         element: <Contactus/>,
//       },
//       {
//         path: "ibdp-handbook",
//         element: <Ibdphandbook/>,
//       },
//       {
//         path: "igcse-booklist",
//         element: <IgcseBooklist/>,
//       },
//       {
//         path: "pdf",
//         element: <Pdf1/>,
//       },

//       {
//         path: "pyp-syllabus",
//         element: <Pypsyllabus/>
//       },
//       {
//         path: "infra",
//         element: <Infra/>
//       },
//       {
//         path: "sports",
//         element: <Sports/>
//       },
//       {
//         path: "career",
//         element: <Career/>
//       },


//       // {
//       //   path: "about",
//       //   element: <About />,
//       // },
//       // {
//       //   path: "mission",
//       //   element: <Mission />,
//       // },
//       // {
//       //   path: "inspiration",
//       //   element: <WebDesign />,
//       // },
//       // {
//       //   path: "headofschool",
//       //   element: <Headofschool/>,
//       // },
//       // {
//       //   path: "fee-structure",
//       //   element: <Feestructure/>,
//       // },
//       // {
//       //   path: "Ourstaff",
//       //   element: <NodeJs />,
//       // },
//       // {
//       //   path: "php",
//       //   element: <Php />,
//       // },
//       // {
//       //   path: "seo",
//       //   element: <SEO />,
//       // },
//     ],
//   },
// ]);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>

//     <RouterProvider router={router} />
  
//   </React.StrictMode>
// );




import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Root from "./routes/root";
import Home from "./routes/home";
import ErrorPage from "./routes/error-page"; // Fix this import
import About from "./routes/about";
import Mission from "./routes/mission";
import Inspiration from "./routes/inspiration";
import Headofschool from "./routes/headofschool";
import Feestructure from "./routes/feestructure";
import Ourstaff from "./routes/ourstaff";
import Pyp from "./routes/pyp";
import Ibdp from "./routes/ibdp";
import Igcse from './routes/igcse';
import Policy from "./routes/policy"; 
import Ibdphandbooks from "./routes/ibdphandbooks";
import Cashandbooks from "./routes/cashandbooks";
import Tokhandbooks from "./routes/tokhandbooks";
import Eehandbooks from "./routes/eehandbooks";
import Syllabus from "./routes/syllabus";
import BookList from "./routes/bookList";
import Curriculum from "./routes/curriculum";
import Pyppoi from "./routes/pyppoi";
import Popyp from "./routes/popyp";
import Parentorientationforpyp from "./routes/parentorientationforpyp";
import Parentorientationibdp from "./routes/parentorientationibdp";
import Mycalendar from "./routes/mycalendar";
import Holidayhomework from "./routes/holidayhomework";
import Homeassignments from "./routes/homeassignments";
import Circular from "./routes/circular";
import Newsletter from "./routes/newsletter";
import Igceadmission from "./routes/igceadmission";
import Ibdpadmission from "./routes/ibdpadmission";
import Onlineregistration from "./routes/onlineregistration";
import Ibupdate from "./routes/ibupdate";
import Events from "./routes/events";
import Classexhibition from "./routes/classexhibition";
import Celebrations from "./routes/celebrations";
import News from "./routes/news";
import Videos from "./routes/videos";
import Casexperiences from "./routes/casexperiences";
import Schooltrips from "./routes/schooltrips";
import Visualarts from "./routes/visualarts";
import Onlinefess from "./routes/onlinefees";
import Achievements from "./routes/achievements";
import Placements from "./routes/placements";
import Careercounselling from "./routes/careercounselling";
import Contactus from "./routes/contactus";
import Ibdphandbook from "./routes/ibdp-handbook";
import Pypsyllabus from "./routes/pypsyllabus";
import Admission from "./routes/admission";
import IgcseBooklist from "./routes/igcsebooklist";
import Infra from "./routes/infra";
import Sports from "./routes/sports";
import Career from "./routes/career";
import Alumni from "./routes/alumni";
import StudentCouncil from "./routes/studentCouncil";


import 'react-big-calendar/lib/css/react-big-calendar.css';
import AdmissionAlert from "./components/AdmissionAlert";
import AdminEvents from "./routes/adminEvents";

// Define Routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />, // Your main layout
    errorElement: <ErrorPage />, // Fix ErrorPage import
    children: [
      
        {
          index: true,        // Default route (instead of `path: "/"`)
          element: <Home />,  // Ensure `Home.js` exists
        },
      { path: "about", element: <About /> },
      {path: "ibupdate", element: <Ibupdate/>},
      { path: "mission", element: <Mission /> },
      { path: "inspiration", element: <Inspiration /> },
      { path: "headofschool", element: <Headofschool /> },
      { path: "feestructure", element: <Feestructure /> },
      { path: "onlinefess", element: < Onlinefess /> },
      

      { path: "ourstaff", element: <Ourstaff /> },
      { path: "pyp", element: <Pyp /> },

      
      
      { path: "igcse", element: <Igcse /> },
      { path: "ibdp", element: <Ibdp /> },
      { path: "policy", element: <Policy /> },
      { path: "ibdphandbooks", element: <Ibdphandbooks /> },
      { path: "cashandbooks", element: <Cashandbooks /> },
      { path: "tokhandbooks", element: <Tokhandbooks /> },
      { path: "eehandbooks", element: <Eehandbooks /> },
      { path: "syllabus", element: <Syllabus /> },
      { path: "bookList", element: <BookList /> },
      { path: "curriculum", element: <Curriculum /> },
      { path: "pyppoi", element: <Pyppoi /> },
      { path: "popyp", element: <Popyp /> },
      { path: "parentorientationforpyp", element: <Parentorientationforpyp /> },
      { path: "parentorientationibdp", element: <Parentorientationibdp /> },
      { path: "calendar", element: <Mycalendar /> },
      { path: "holidayhomework", element: <Holidayhomework /> },
      { path: "homeassignments", element: <Homeassignments /> },
      { path: "circular", element: <Circular /> },
      { path: "newsletter", element: <Newsletter /> },
      { path: "igceadmission", element: <Igceadmission /> },
      { path: "admission", element: <Admission /> },
      { path: "ibdpadmission", element: <Ibdpadmission /> },
      { path: "onlineregistration", element: <Onlineregistration /> },
      { path: "ibupdate", element: <Ibupdate /> },
      { path: "events", element: <Events /> },
      { path: "classexhibition", element: <Classexhibition /> },
      { path: "celebrations", element: <Celebrations /> },
      { path: "news", element: <News /> },
      { path: "videos", element: <Videos /> },
      { path: "casexperiences", element: <Casexperiences /> },
      { path: "schooltrips", element: <Schooltrips /> },
      { path: "visualarts", element: <Visualarts /> },
      // { path: "onlinefees", element: <Onlinefess /> }, // Fixed "onlinefess" typo
      { path: "achievements", element: <Achievements /> },
      { path: "placements", element: <Placements /> },
      { path: "careercounselling", element: <Careercounselling /> },
      { path: "contact", element: <Contactus /> },
      { path: "ibdp-handbook", element: <Ibdphandbook /> },
      { path: "igcse-booklist", element: <IgcseBooklist /> },
      { path: "pyp-syllabus", element: <Pypsyllabus /> },
      { path: "infra", element: <Infra /> },
      { path: "sports", element: <Sports /> },
      { path: "career", element: <Career /> },
      { path: "alumni", element: <Alumni /> },
      { path: "studentCouncil", element: <StudentCouncil/> },
      { path: "admin-events", element: <AdminEvents />},
      
      
    ],
  },
]);

// ---------------- GLOBAL WRAPPER ----------------
function AppWrapper() {
  const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setOpenPopup(true);
    }, 3000);
  }, []);

  return (
    <>
      {/* Global Popup */}
      <AdmissionAlert open={openPopup} onClose={() => setOpenPopup(false)} />
             {/* yaha baaki website ka UI hoga */}

      {/* Main App */}
      <RouterProvider router={router} />
    </>
  );
}


// Render Router
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <RouterProvider router={router} />
    
//   </React.StrictMode>
// );


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);